import React, { useEffect, useState, useContext } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { listFeature, setEnableFeature } from '../Network/Administration'
import { Loading } from '../Library'
import FeatureItem from './FeatureItem'
import "./Feature.css"

function Feature() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    const [isLoading, setLoading] = useState(false)
    const [featureList, setFeatureList] = useState([])

    const fetchData = () =>{
        setLoading(true)
        listFeature(
            (data)=>{ 
                setFeatureList(data)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            }
        )
    }

    const toggleEnable = (featureId, isEnable) =>{
        setEnableFeature(featureId, isEnable,
            ()=>{
                fetchData()
            },
            ()=>{ })
    }

    useEffect(()=>{
        fetchData()
    },[])

    return (
        <div id="feature">
            { isLoading ? <Loading/>: null }
            <div style={{ marginBottom: 18 }}>{lang.feature_detail}</div>
            <div className="feature-container">
                { featureList.map((item, key)=>
                    <FeatureItem
                    key={key}
                    title={item.featureName}
                    detail={item.featureDetail}
                    identifier={item.identifier}
                    isEnable={item.isEnable}
                    onToggle={()=>{
                        toggleEnable(item.id, !item.isEnable ? true:false)
                    }}
                    />
                )}
            </div>
        </div>
    )

}

export default Feature
